const translations = {
    battery: 'Battery',
    flowMeter: 'Flow meter',
    motor: 'Motor',
    noPartsFound: 'No parts found.',
    propellerSet: 'Propeller set',
    pump: 'Pump',
    search: 'Search'
};

export default translations;
